import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const normalizeFileName = (value, extension) => {
  if (!value || !extension) {
    return value;
  }
  const extensionRegex = new RegExp(`${escapeRegex(extension)}$`, "i");
  const baseName = value.replace(extensionRegex, "");
  if (!baseName) {
    return value;
  }
  return `${baseName}${extension}`;
};

function FileNameTextField({ control, extension }) {
  return (
    <Controller
      name="fileName"
      control={control}
      rules={{
        required: true,
      }}
      render={({ field, formState: { errors } }) => {
        const handleBlur = (event) => {
          const normalizedValue = normalizeFileName(
            event.target.value,
            extension
          );
          field.onChange(normalizedValue);
          field.onBlur();
        };

        return (
          <TextField
            {...field}
            onChange={field.onChange}
            onBlur={handleBlur}
            variant="outlined"
            label="Dokumentname"
            fullWidth
            required
            error={errors.fileName}
            helperText={
              errors.fileName
                ? "Bitte angeben"
                : "Der Dateityp wird automatisch hinzugefügt."
            }
          />
        );
      }}
    />
  );
}

FileNameTextField.propTypes = {
  control: PropTypes.object,
  extension: PropTypes.string,
};

export default FileNameTextField;
